module.exports = __webpack_public_path__ + "statics/img/none.d852f457.png";